import DOMPurify from 'dompurify';

export const sanitize = (html) => {
  DOMPurify.addHook('beforeSanitizeElements', (node) => {
    // this is required to be done due to https://developer.mozilla.org/en-US/docs/Web/API/DOMParser
    if (node.nodeName.includes('text') && node.previousElementSibling?.tagName.includes('UL')) {
      node.textContent = node.textContent.trim();

      const previousElementSibling = node.previousElementSibling;
      const element = document.createElement('p');
      element.appendChild(node);

      return previousElementSibling.after(element);
    }
    return node;
  });

  DOMPurify.addHook('afterSanitizeElements', (node) => {
    // this removes the empty P elements and adds a new line break to the previous sibling when it's a UL
    if (node.nodeName === 'P') {
      if (node?.nextElementSibling?.tagName.includes('UL')) {
        node?.insertAdjacentText('afterend', '\n');
        node.textContent = node.textContent.trim();
        node.nextElementSibling.previousSibling.textContent =
          node.nextElementSibling.previousSibling.textContent.replace(/\n/g, '');
      }

      if (node?.previousElementSibling?.tagName.includes('UL')) {
        node.insertAdjacentText('beforebegin', '\n');
        node.previousElementSibling.nextSibling.textContent =
          node.previousElementSibling.nextSibling.textContent.replace(/\n/g, '');
      }
      if (['\n', ''].includes(node.textContent)) {
        return node?.parentNode?.removeChild(node);
      }
      return node;
    }

    return node;
  });

  const sanitized = DOMPurify.sanitize(html, {
    FORBID_TAGS: ['img']
  });

  return sanitized;
};
